import angular from 'angular';

const promotionsServices = angular.module('applicationModule.promotionsServices', []);

promotionsServices.factory('Promotion', ['$http', 'PromotionAPI', 'AppsoupAPI', function ($http, PromotionAPI, AppsoupAPI) {
    'use strict';

    const API_URL = AppsoupAPI.API_URL + '/app/promotions/';

    return {
        getList: function (appId, params) {
            return PromotionAPI.getList(appId, params)
                .then(function (response) {
                    return response.data;
                });
        },
        remove: function (promotionId) {
            return PromotionAPI.remove(promotionId);
        },
        get: function (promotionId, appId) {
            return PromotionAPI.get(promotionId, appId);
        },
        save: function (data, editMode) {
            return PromotionAPI.save(data, editMode);
        },
        search: function (appId, search) {
            return PromotionAPI.search(appId, search);
        },
        searchTypes: function (appId, search) {
            return PromotionAPI.searchTypes(appId, search);
        },
        searchProducts: function (appId, search) {
            return PromotionAPI.searchProducts(appId, search);
        },
        copyPromotion: function (promotionId) {
            return PromotionAPI.copyPromotion(promotionId);
        },
        importProducts: function (appId, promotionId, file, mergeType) {
            return PromotionAPI.importProducts(appId, promotionId, file, mergeType);
        },
        updateProduct: function (productId, appId) {
            return PromotionAPI.updateProduct(productId, appId);
        },
        export: function (date, appId) {
            return $http.post(API_URL + 'export/data', {application_id: appId, date: date});
        },
        bulkDelete: function (ids) {
            return PromotionAPI.bulkDelete(ids);
        },
        changeStatuses: function (ids, status) {
            return PromotionAPI.changeStatuses(ids, status);
        },
        exportProducts: function (promotionId, appId) {
            return PromotionAPI.exportProducts(promotionId, appId);
        },
        importPromotions: function (appId, file) {
            return PromotionAPI.importPromotions(appId, file);
        },
        getExampleXls: function () {
            return PromotionAPI.getExampleXls();
        }
    };
}]);

promotionsServices.service('PromotionAPI', ['$http', 'AppsoupAPI', 'Upload', function ($http, AppsoupAPI, Upload) {
    'use strict';

    const API_URL = AppsoupAPI.API_URL + '/app/promotions/';

    this.getList = function (appId, params) {
        return $http.get(API_URL, {params: angular.extend(AppsoupAPI.getTableParams(params), {app_id: appId})});
    };

    this.remove = function (promotionId) {
        return $http.delete(API_URL + promotionId);
    };

    this.get = function (promotionId, appId) {
        return $http.get(API_URL + promotionId, {params: {app_id: appId}});
    };

    this.save = function (data, editMode) {
        if (editMode) {
            return $http.put(API_URL + data.id, data);
        } else {
            return $http.post(API_URL, data);
        }
    };

    this.search = function (appId, search) {
        return $http.get(API_URL + appId + '/tags', {params: {search: search}});
    };

    this.searchTypes = function (appId, search) {
        return $http.get(API_URL + appId + '/types', {params: {search: search}});
    };

    this.searchProducts = function (appId, search) {
        return $http.get(API_URL + appId + '/products/', {params: {search: search}});
    };

    this.copyPromotion = function (promotionId) {
        return $http.post(API_URL + 'copy/' + promotionId);
    };

    this.importProducts = function (appId, promotionId, file, mergeType) {
        return Upload.upload({
            url: API_URL + appId + '/import/data/' + promotionId,
            method: 'POST',
            sendObjectsAsJsonBlob: false,
            fields: {
                merge_type: mergeType
            },
            file: file
        });
    };

    this.updateProduct = function (productId, appId) {
        return $http.get(API_URL + 'update/product/' + appId + '/' + productId);
    };

    this.bulkDelete = function (ids) {
        return $http.post(API_URL + 'bulk/action/delete', {ids: ids});
    };

    this.changeStatuses = function (ids, status) {
        return $http.post(API_URL + 'bulk/action/change-statuses', {ids: ids, status: status});
    };

    this.exportProducts = function (promotionId, appId) {
        return $http.get(API_URL + 'export/products/' + appId + '/' + promotionId);
    };

    this.importPromotions = function (appId, file) {
        return Upload.upload({
            url: API_URL + appId + '/data/import',
            method: 'POST',
            sendObjectsAsJsonBlob: false,
            fields: {},
            file: file
        });
    };

    this.getExampleXls = function () {
        return $http.get(API_URL + 'download/example');
    };
}]);

export default promotionsServices;
